import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { axiosInstance } from '../../../../api/axios';
import APIEndpoints from '../../../api/APIEndpoints';
import CookiesService from '../../../shared/CookiesService';
import { HttpSuccessCodes } from '../../../errorhandling/HttpErrorCodes';
import CreateJWToken from '../../../shared/JWToken/CreateJWToken';
import HttpHeader from '../../../shared/httpheader';
import { setBearerToken } from '../../../../redux/app/userSlice';
import { CONTENT_PAGE_TITLES } from '../../../../constants';
import * as yup from 'yup';
import parse from 'html-react-parser';
import ApiEncrypt from '../../../utils/Encrypt';

const useAccountSetup = (props) => {
  const countryCodeList = [{ label: '+1', value: '+1' }];

  const formFields = {
    Oid: '',
    UserType: '',
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    confirmEmail: '',
    password: '',
    ForcePasswordReset: false,
    Status: 'Active',
    SuperUser: '',
    countryCode: countryCodeList[0],
    contactNumber: '',
    jobTitle: '',
    employeeId: '',
    address: '',
    brokerDetails: '',
    securityQuestionDetails: '',
    othersOid: '',
    mappedenties: '',
    userprovideraffiliationdetails: '',
    is_doctorfacility: false,
  };

  const id = useParams();
  const dispatch = useDispatch();
  const [currentStep, setCurrentStep] = useState(1);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [passwordRules, setPasswordRules] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [userData, setUserData] = useState(formFields);
  const [formData, setFormData] = useState(formFields);
  const [serverError, setServerError] = useState(false);

  //const [ disclaimerContent, setDisclaimerContent ] = useState( '' );
  const [privacyPolicyContent, setPrivacyPolicyContent] = useState('');
  const [termsConditionContent, setTermsConditionContent] = useState('');
  const [selectedQuestionValues, setSelectedQuestionValues] = useState([
    null,
    null,
    null,
  ]);
  const [isButtonDisable, setIsButtonDisable] = useState(true);
  const [registrationUserDetails, setRegistrationUserDetails] = useState({});
  const [showSkeletonLoader, setShowSkeletonLoader] = useState(true);
  const [registrationUrlValid, setRegistrationUrlValid] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);
  const [fetchSecurityQuestions, setFetchSecurityQuestions] = useState(false);
  const [insurerClientSettings, setInsurerClientSettings] = useState({});
  const { encryptData } = ApiEncrypt();

  const Rules = {
    passMinLength: passwordRules.PasswordMinLength,
    passMaxLength: passwordRules.PasswordMaxLength,
    passNumericsReq: passwordRules.NoOfNumericsReqd,
    passSpecialCharReq: passwordRules.NoOfSpecialCharactersReqd,
    passUpperCaseReq: passwordRules.NoOfUpperCaseReqd,
    passLowerCaseReq: true,
  };

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    if (currentStep === 3) {
      setFetchSecurityQuestions(false);
    }
    setCurrentStep(currentStep - 1);
  };

  const handleSecurityQuestionsError = (isError) => {
    console.log('handleSecurityQuestionsError :::::', isError);
    setFetchSecurityQuestions(isError);
  };

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const schema = yup.object({
    contactNumber: yup
      .string()
      .matches(phoneRegExp, 'Enter valid phone number')
      .min(12, 'Minimum 10 digits')
      .max(12, 'Maximum 10 digits'),
    jobTitle: yup.string().max(55, ' Enter maximum 55 characters only'),
    employeeId: yup.string().max(20, ' Enter maximum 20 characters only'),
    address: yup.string().max(99, ' Enter maximum 99 characters only'),
  });

  const regexSpecialChar = new RegExp(
    /^((?=.*[-!$%^&*()/_\\+|~='"\]`{}:[;<>?,.@#]){1}).*$/,
  );

  const passwordSchema = yup.object({
    password: yup
      .string()
      .test((value, context) => {
        const { createError } = context;

        if (!value) {
          return createError({
            message: 'The Password field is required',
          });
        } else if (
          Rules.passMaxLength >= 1 &&
          !formData.SuperUser &&
          value.length > Rules.passMaxLength
        ) {
          return createError({
            message: `Enter a maximum of ${Rules.passMaxLength} characters only`,
          });
        } else if (
          Rules.passMinLength >= 1 &&
          value.length < (formData.SuperUser ? 12 : Rules.passMinLength)
        ) {
          return createError({
            message: `Enter a minimum of ${
              formData.SuperUser ? 12 : Rules.passMinLength
            } characters only`,
          });
        } else if (
          Rules.passUpperCaseReq >= 1 &&
          value.match('(?=.*[A-Z])') === null
        ) {
          return createError({
            message: formData?.SuperUser
              ? 'Enter at least one uppercase letter'
              : 'Please consult password rules',
          });
        } else if (
          Rules.passSpecialCharReq >= 1 &&
          !regexSpecialChar.test(value)
        ) {
          return createError({
            message: formData?.SuperUser
              ? 'Enter at least one special character'
              : 'Please consult password rules',
          });
        } else if (
          Rules.passNumericsReq >= 1 &&
          value.match('(?=.*[0-9])') === null
        ) {
          return createError({
            message: formData?.SuperUser
              ? 'Enter at least one numeric letter'
              : 'Please consult password rules',
          });
        } else {
          return true;
        }
      })
      .required('Enter Password'),

    confirmPassword: yup
      .string()
      .required('Enter Confirm Password')
      .when('password', {
        is: (val) => (val && val.length > 0 ? true : false),
        then: () =>
          yup.string().oneOf([yup.ref('password')], 'Passwords do not match'),
      }),
  });

  const getPasswordRules = async () => {
    setSkeletonLoader(true);
    const responseConfiguration = await axiosInstance.get(
      APIEndpoints.getAdminConfigResources(),
    );
    const adminConfig = responseConfiguration.data;
    console.log('getPasswordRules ::::::: >>>>> :::::::::: ', adminConfig);
    setPasswordRules(adminConfig?.Response?.PasswordRules);
    setInsurerClientSettings(adminConfig?.Response?.InsurerClientSettings);
    setSkeletonLoader(false);
  };

  useEffect(() => {
    //UserID
    //registrationUserDetails.Response.UserEmail
    if (props?.defaultUserData) {
      if (props?.defaultUserData.UserID) {
        setRegistrationUserDetails({
          Response: { UserEmail: props.defaultUserData.UserID },
        });
      }
    }
  }, [props?.defaultUserData]);

  //const getEncryptionKey = async () => {
  //localStorage.removeItem( 'encryptionKey' );
  //const encrptionKey = await Promise.all( [ HttpHeader.getEncryptionKeyStore() ] );
  //console.log("Encryp Key ::::::   ", encrptionKey);
  //};

  const getEncryptionKeyRegistration = async () => {
    try {
      const keyStoreResp = await axiosInstance.get(
        APIEndpoints.getEncryptionKeyResources(),
      );
      console.log(
        'getEncryptionKeyRegistration outSide :::::::::::::::::::: >>>>>>>>>> ',
      );
      if (keyStoreResp.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        console.log(
          'getEncryptionKeyRegistration Inside :::::::::::::::::::: >>>>>>>>>> ',
        );
        getUserRegistrationDetails();
      }
    } catch (e) {
      console.log('Error in useAccountSetup >>>> getEncryptionKey  :::::: ', e);
      setServerError(true);
    }
  };

  const getUserRegistrationDetails = async () => {
    console.log('getUserRegistrationDetails :::::::::: in ::::::::::::');
    let createJWT;
    setShowSkeletonLoader(true);
    try {
      if (id.id) {
        createJWT = await CreateJWToken.createJWToken('Forgot Password');
        console.log('JWT Token ::::::::::::::   ', CreateJWToken.getJWTToken());
        dispatch(setBearerToken('Bearer ' + CreateJWToken.getJWTToken()));
        getPageContent();
        console.log(
          'URL :::::::::: onboarding >>>>>>>>>>> ::::::::: ',
          `${APIEndpoints.getUserRegistrationDetails()}/${id.id}`,
        );
        const responseUserRegistrationDetails = await axiosInstance.get(
          `${APIEndpoints.getUserRegistrationDetails()}/${id.id}`,
        );
        console.log(
          'responseUserRegistrationDetails::::::::::::  onboarding  >>>>>>>>>   :::::  ',
          responseUserRegistrationDetails,
        );
        if (
          responseUserRegistrationDetails.status ===
          HttpSuccessCodes.HTTP_SUCCESS_CODE_200
        ) {
          setRegistrationUserDetails(responseUserRegistrationDetails.data);
          if (
            responseUserRegistrationDetails?.data?.Response?.IsExpired ===
            'true'
          ) {
            setRegistrationUrlValid(true);
          }
          if (
            responseUserRegistrationDetails?.data?.Response?.IsRegistered ===
            'true'
          ) {
            setIsRegistered(true);
          }
        }
        setShowSkeletonLoader(false);
      }
    } catch (e) {
      setShowSkeletonLoader(false);
      setServerError(true);
      console.log('Error in User Registration URL :::::: ', e);
    }
  };

  const getUserDetails = async () => {
    setShowSkeletonLoader(true);
    try {
      //console.log("RegistrationUserDetails    ::::::: onboarding>>>> ::::  ", registrationUserDetails);
      console.log(
        'getUserDetails :::::::::: onboarding >>>>>>>>>>> ::::::::: ',
        `${APIEndpoints.getUserDetailsOnBoarding()}`,
      );
      const responseGetUserDetails = await axiosInstance.get(
        `${APIEndpoints.getUserDetailsOnBoarding()}/${
          registrationUserDetails.Response.UserEmail
        }`,
      );
      console.log(
        'responseGetUserDetails::::::::::::  onboarding  >>>>>>>>>   :::::  ',
        responseGetUserDetails,
      );
      if (
        responseGetUserDetails.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200
      ) {
        const {
          FirstName,
          MiddleName,
          LastName,
          UserID,
          UserType,
          Oid,
          SuperUser,
          BrokerDetails,
          MappedEnties,
          UserProviderAffiliationDetails,
          CellPhone,
          Address,
          JobTitle,
          EmployeeId,
          Is_DoctorFacility,
        } = responseGetUserDetails.data.Response.User;
        setUserData({
          ...userData,
          firstName: FirstName,
          middleName: MiddleName !== 'null' ? MiddleName : '',
          lastName: LastName,
          email: UserID,
          confirmEmail: UserID,
        });

        setFormData({
          ...formData,
          Oid: Oid,
          UserType: UserType,
          firstName: FirstName,
          middleName: MiddleName !== 'null' ? MiddleName : '',
          lastName: LastName,
          email: UserID,
          confirmEmail: UserID,
          SuperUser: SuperUser,
          brokerDetails: BrokerDetails ? BrokerDetails : [],
          mappedenties: MappedEnties,
          userprovideraffiliationdetails: UserProviderAffiliationDetails,
          contactNumber: CellPhone,
          jobTitle: JobTitle,
          address: Address,
          employeeId: EmployeeId,
          is_doctorfacility: Is_DoctorFacility,
        });
      }

      setShowSkeletonLoader(false);
    } catch (e) {
      setShowSkeletonLoader(false);
      setServerError(true);
      console.log('Error in getUserDetails :::::: ', e);
    }

    //const adminConfig = responseConfiguration.data;
    //setPasswordRules( adminConfig?.Response?.PasswordRules );
    //setSkeletonLoader( false );
  };

  const securityQuestionschema = yup.object({
    question1: yup
      .object()
      .required('Question selection is required')
      .nullable(),
    question2: yup
      .object()
      .required('Question selection is required')
      .nullable(),
    question3: yup
      .object()
      .required('Question selection is required')
      .nullable(),
    answer1: yup
      .string()
      .required('Answer is required')
      .min(4, 'Answer must be at least 4 characters')
      .max(128, 'Answer must not exceed 128 characters')
      .test(
        'Checking answer 1 and 2',
        'Answer should not be same',
        function (value) {
          return value ? value !== this.parent.answer2 : true;
        },
      )
      .test(
        'Checking answer 1 and 3',
        'Answer should not be same',
        function (value) {
          return value ? value !== this.parent.answer3 : true;
        },
      ),
    answer2: yup
      .string()
      .required('Answer is required')
      .min(4, 'Answer must be at least 4 characters')
      .max(128, 'Answer must not exceed 128 characters')
      .test(
        'Checking answer 2 and 1',
        'Answer should not be same',
        function (value) {
          return value ? value !== this.parent.answer1 : true;
        },
      )
      .test(
        'Checking answer 2 and 3',
        'Answer should not be same',
        function (value) {
          return value ? value !== this.parent.answer3 : true;
        },
      ),
    answer3: yup
      .string()
      .required('Answer is required')
      .min(4, 'Answer must be at least 4 characters')
      .max(128, 'Answer must not exceed 128 characters')
      .test(
        'Checking answer 3 and 1',
        'Answer should not be same',
        function (value) {
          return value ? value !== this.parent.answer1 : true;
        },
      )
      .test(
        'Checking answer 3 and 2',
        'Answer should not be same',
        function (value) {
          return value ? value !== this.parent.answer2 : true;
        },
      ),
    customQuestion1: yup.string().when('question1', {
      is: (question1) => question1 && question1.value === 'Others',
      then: () =>
        yup
          .string()
          .required('Question is required')
          .min(10, 'Question must be at least 10 characters')
          .max(256, 'Question must not exceed 256 characters')
          .test(
            'Checking Custom Question 1 and 2',
            'Question should not be same',
            function (value) {
              return value ? value !== this.parent.customQuestion2 : true;
            },
          )
          .test(
            'Checking Custom Question 1 and 3',
            'Question should not be same',
            function (value) {
              return value ? value !== this.parent.customQuestion3 : true;
            },
          ),
    }),
    customQuestion2: yup.string().when('question2', {
      is: (question2) => question2 && question2.value === 'Others',
      then: () =>
        yup
          .string()
          .required('Question is required')
          .min(10, 'Question must be at least 10 characters')
          .max(256, 'Question must not exceed 256 characters')
          .test(
            'Checking Custom Question 2 and 1',
            'Question should not be same',
            function (value) {
              return value ? value !== this.parent.customQuestion1 : true;
            },
          )
          .test(
            'Checking Custom Question 2 and 3',
            'Question should not be same',
            function (value) {
              return value ? value !== this.parent.customQuestion3 : true;
            },
          ),
    }),
    customQuestion3: yup.string().when('question3', {
      is: (question3) => question3 && question3.value === 'Others',
      then: () =>
        yup
          .string()
          .required('Question is required')
          .min(10, 'Question must be at least 10 characters')
          .max(256, 'Question must not exceed 256 characters')
          .test(
            'Checking Custom Question 3 and 1',
            'Question should not be same',
            function (value) {
              return value ? value !== this.parent.customQuestion1 : true;
            },
          )
          .test(
            'Checking Custom Question 3 and 2',
            'Question should not be same',
            function (value) {
              return value ? value !== this.parent.customQuestion2 : true;
            },
          ),
    }),
  });

  const getPageContent = async () => {
    try {
      const getLinks = await axiosInstance.get(APIEndpoints.linksResource());
      //const disclaimerPage = await getLinks?.data?.Response?.Links?.filter( item => item.LinkTitle === CONTENT_PAGE_TITLES.regDisclaimer );
      const privacyPage = await getLinks?.data?.Response?.Links?.filter(
        (item) => item.LinkTitle === CONTENT_PAGE_TITLES.regPrivacyPolicy,
      );
      const termsPage = await getLinks?.data?.Response?.Links?.filter(
        (item) => item.LinkTitle === CONTENT_PAGE_TITLES.regTermsAndConditions,
      );

      //const disclaimerResponse = await axiosInstance.get( APIEndpoints.pageResource() + '/oid/' + disclaimerPage[ 0 ][ 'PageOID' ] );
      const privacyResponse = privacyPage.length
        ? await axiosInstance.get(
            APIEndpoints.pageResource() + '/oid/' + privacyPage[0]['PageOID'],
          )
        : null;
      const termsResponse = termsPage.length
        ? await axiosInstance.get(
            APIEndpoints.pageResource() + '/oid/' + termsPage[0]['PageOID'],
          )
        : null;

      //const disclaimerContentHTML = parse( JSON.parse( disclaimerResponse?.data.Response?.PageContent ) );
      const privacyContentHTML = privacyPage.length
        ? parse(JSON.parse(privacyResponse?.data.Response?.PageContent))
        : null;
      const termsContentHTML = termsPage.length
        ? parse(JSON.parse(termsResponse?.data.Response?.PageContent))
        : null;

      //setDisclaimerContent( disclaimerContentHTML );
      setPrivacyPolicyContent(privacyContentHTML);
      setTermsConditionContent(termsContentHTML);
    } catch (e) {
      console.log('GetPageContent::::::::::::::   ', e);
    }
  };
  const handleInput = (e, setFieldValue, handleChange) => {
    handleChange(e);
    setFormData({ ...formData, [e.currentTarget.name]: e.currentTarget.value });
    setFieldValue(e.currentTarget.name, e.currentTarget.value);
    //if(e.currentTarget.name === 'contactNumber') {
    //setFormData( {...formData, contactNumber: e.currentTarget.value.replaceAll(/-/g,"")} );
    //}
  };

  const handleQuestionValChange = (option, index) => {
    const newQuestionVals = selectedQuestionValues;
    newQuestionVals[index] = option;
    setSelectedQuestionValues([...newQuestionVals]);
    setIsButtonDisable(false);
  };

  const handleFormData = (keyName, val) => {
    setFormData({ ...formData, [keyName]: val });
  };

  const getBrokerId = () => {
    const brokerIds = [];
    if (formData.brokerDetails) {
      formData.brokerDetails.map((b) => brokerIds.push(b.Code));
    }
    console.log(' Broker Ids :::::::::::::::>>>>> :::::::::::  ', brokerIds);
    return brokerIds;
  };

  const updateSecurityQuestions = async () => {
    const {
      question1,
      question2,
      question3,
      answer1,
      answer2,
      answer3,
      customQuestion1,
      customQuestion2,
      customQuestion3,
    } = formData.securityQuestionDetails;
    const securityQuestionsPayload = {
      SecurityQuestions: [
        {
          oid:
            question1['value'] === 'Others'
              ? formData.othersOid
              : question1['value'],
          securityquestion: customQuestion1
            ? customQuestion1
            : question1['label'],
          answer: answer1,
          custom: question1['value'] === 'Others' ? true : false,
        },
        {
          oid:
            question2['value'] === 'Others'
              ? formData.othersOid
              : question2['value'],
          securityquestion: customQuestion2
            ? customQuestion2
            : question2['label'],
          answer: answer2,
          custom: question2['value'] === 'Others' ? true : false,
        },
        {
          oid:
            question3['value'] === 'Others'
              ? formData.othersOid
              : question3['value'],
          securityquestion: customQuestion3
            ? customQuestion3
            : question3['label'],
          answer: answer3,
          custom: question3['value'] === 'Others' ? true : false,
        },
      ],
      UserID: formData.email,
    };
    console.log(
      'securityQuestionsPayload :::::::::: >>>>>>>>>>> ::::::::: ',
      securityQuestionsPayload,
    );
    try {
      const response = await axiosInstance.post(
        APIEndpoints.postSecurityQuestions(),
        securityQuestionsPayload,
      );
      if (
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        return new Promise((resolve, reject) => {
          resolve('Success!');
        });
      } else {
        return new Promise((resolve, reject) => {
          reject(
            'We are unable to update security questions. Please try again!',
          );
        });
      }
    } catch (e) {
      return new Promise((resolve, reject) => {
        reject(e);
      });
    }
  };

  const updateUser = async () => {
    console.log('updateUser formData', formData);

    const {
      Oid,
      UserType,
      firstName,
      lastName,
      email,
      password,
      Status,
      SuperUser,
      contactNumber,
      employeeId,
      jobTitle,
      address,
      brokerDetails,
      mappedenties,
      userprovideraffiliationdetails,
      is_doctorfacility,
    } = formData;

    console.log(
      'updateUser userprovideraffiliationdetails',
      userprovideraffiliationdetails,
    );

    const providerObj = [];
    userprovideraffiliationdetails &&
      userprovideraffiliationdetails.map((doc) => {
        return doc.FacilityDetails.map((d) => {
          providerObj.push({
            FacilityOid: d.FacilityOID,
            PhysicianData: d.PhysicianDetails.map((p) => {
              return {
                PhysicianOid: p.PhysicainOid,
                ConnectorId: p.ConnectorID,
              };
            }),
          });
        });
      });

    /*userprovideraffiliationdetails && userprovideraffiliationdetails.forEach((facilityItem, index) => {
      const payloadData = {
        'FacilityOid' : facilityItem.FacilityOid,
        'PhysicianData' : facilityItem.FacilityDetails.length > 0 ?
          facilityItem.FacilityDetails.map(doc => {
            return doc.PhysicianDetails.map(d => {
              return {
                'PhysicianOid' : d.PhysicainOid,
                'ConnectorId' : d.ConnectorID
              }
            })
          })
        : []
      }
      console.log('updateUser payloadData', payloadData);
    })*/

    let updateUserPayload = {
      Oid: Oid,
      UserType: UserType,
      FirstName: firstName,
      LastName: lastName,
      UserID: email,
      Password: encryptData(password, false),
      ToResetPassword: false,
      Status: Status,
      SuperUser: SuperUser,
      CellPhone: contactNumber ? contactNumber.replaceAll(/-/g, '') : '',
      EmployeeId: employeeId,
      JobTitle: jobTitle,
      Address: address,
      brokerid: brokerDetails ? getBrokerId() : [],
      MappedEnties: mappedenties,
      PrivacyAccepted: true,
      TermsAccepted: true,
      TimeZone: '',
      Locale: '',
      DateFormat: '',
      TimeFormat: '',
      Description: '',
      UserProviderAffiliationDetails: providerObj,
    };
    if (UserType === 'Provider') {
      updateUserPayload = {
        ...updateUserPayload,
        Is_DoctorFacility: is_doctorfacility,
      };
    }
    const payLoad = {
      UpdateUser: updateUserPayload,
    };
    console.log(
      'UpdateUser Payload :::::::: >>>>>>>>>>> ::::::::::   ',
      payLoad,
    );
    try {
      const response = await axiosInstance.put(
        APIEndpoints.getUpdateAllUserAPIResource(),
        payLoad,
      );
      if (
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        localStorage.setItem('pwd-reset', true);
        return new Promise((resolve, reject) => {
          resolve('Success!');
        });
      } else {
        return new Promise((resolve, reject) => {
          reject('We are unable to update the details. Please try again!');
        });
      }
    } catch (e) {
      return new Promise((resolve, reject) => {
        reject(e);
      });
    }
  };

  const getStepTitle = () => {
    return currentStep === 2
      ? 'Create Password'
      : currentStep === 3
      ? 'Setup Security Questions'
      : currentStep === 4
      ? '2-Step Verification'
      : currentStep === 5
      ? 'Privacy Policy'
      : currentStep === 6
      ? 'Terms And Conditions'
      : 'Onboarding';
  };

  useEffect(() => {
    if (
      registrationUserDetails &&
      registrationUserDetails.Response &&
      registrationUserDetails.Response.UserEmail
    ) {
      getUserDetails();
      getPasswordRules();
      //getPageContent();
    }
  }, [registrationUserDetails]);

  useEffect(() => {
    getEncryptionKeyRegistration();
    //getPasswordRules();
    //getPageContent();

    //getUserRegistrationDetails();

    //setUserData( {...userData,
    //firstName: CookiesService.get( 'Firstname' ),
    //middleName: CookiesService.get( 'Middlename' ) !== 'null' ? CookiesService.get( 'Middlename' ) : '',
    //lastName: CookiesService.get( 'Lastname' ),
    //email: CookiesService.get( 'UserID' ),
    //confirmEmail: CookiesService.get( 'UserID' ),
    //} );

    //setFormData( {...formData,
    //Oid: CookiesService.get( 'Oid' ),
    //UserType: CookiesService.get( 'UserType' ),
    //firstName: CookiesService.get( 'Firstname' ),
    //middleName: CookiesService.get( 'Middlename' ) !== 'null' ? CookiesService.get( 'Middlename' ) : '',
    //lastName: CookiesService.get( 'Lastname' ),
    //email: CookiesService.get( 'UserID' ),
    //confirmEmail: CookiesService.get( 'UserID' ),
    //SuperUser: CookiesService.get( 'Superuser' )
    //} );
  }, []);

  return {
    currentStep,
    schema,
    passwordSchema,
    securityQuestionschema,
    skeletonLoader,
    passwordRules,
    showPassword,
    showConfirmPassword,
    selectedQuestionValues,
    userData,
    formData,
    privacyPolicyContent,
    termsConditionContent,
    isButtonDisable,
    setShowConfirmPassword,
    setShowPassword,
    handleQuestionValChange,
    nextStep,
    prevStep,
    handleInput,
    updateUser,
    getStepTitle,
    countryCodeList,
    registrationUserDetails,
    handleFormData,
    updateSecurityQuestions,
    showSkeletonLoader,
    registrationUrlValid,
    isRegistered,
    serverError,
    handleSecurityQuestionsError,
    fetchSecurityQuestions,
    insurerClientSettings,
  };
};

export default useAccountSetup;
